// 字符串转字数组
function convertToWordArray(value: string): Array<number> {
  const messageLength = value.length;
  const numberOfWords = ((messageLength + 8 - ((messageLength + 8) % 64)) / 64 + 1) * 16;
  const wordArray = new Array<number>(numberOfWords - 1).fill(0);

  for (let byteCount = 0; byteCount < messageLength; byteCount++) {
    const wordIndex = Math.floor(byteCount / 4);
    const bytePosition = (byteCount % 4) * 8;
    wordArray[wordIndex] |= value.charCodeAt(byteCount) << bytePosition;
  }

  const finalWordIndex = Math.floor(messageLength / 4);
  const finalBytePosition = (messageLength % 4) * 8;
  wordArray[finalWordIndex] |= 0x80 << finalBytePosition;
  wordArray[numberOfWords - 2] = messageLength << 3;
  wordArray[numberOfWords - 1] = messageLength >>> 29;
  return wordArray;
}

// 数字转16进制字符串
function wordToHex(value: number) {
  let hexString = "";
  for (let byteIndex = 0; byteIndex <= 3; byteIndex++) {
    const byteValue = (value >>> (byteIndex * 8)) & 255;
    hexString += `0${byteValue.toString(16)}`.slice(-2);
  }
  return hexString;
}

// 字符串转utf8编码
function utf8Encode(value: string) {
  const normalizedValue = value.replace(/\r\n/gu, "\n");
  let utf8Text = "";

  for (let charIndex = 0; charIndex < normalizedValue.length; charIndex++) {
    const charCode = normalizedValue.charCodeAt(charIndex);

    if (charCode < 128) {
      utf8Text += String.fromCharCode(charCode);
    } else if (charCode > 127 && charCode < 2048) {
      utf8Text += String.fromCharCode((charCode >> 6) | 192);
      utf8Text += String.fromCharCode((charCode & 63) | 128);
    } else {
      utf8Text += String.fromCharCode((charCode >> 12) | 224);
      utf8Text += String.fromCharCode(((charCode >> 6) & 63) | 128);
      utf8Text += String.fromCharCode((charCode & 63) | 128);
    }
  }

  return utf8Text;
}

// 左移位
function rotateLeft(value: number, shiftBits: number) {
  return (value << shiftBits) | (value >>> (32 - shiftBits));
}

// 无符号加法
function addUnsigned(x: number, y: number) {
  const xSignBit = x & 0x80000000;
  const ySignBit = y & 0x80000000;
  const xCarryBit = x & 0x40000000;
  const yCarryBit = y & 0x40000000;
  const lowBitsSum = (x & 0x3fffffff) + (y & 0x3fffffff);
  if (xCarryBit & yCarryBit) return lowBitsSum ^ 0x80000000 ^ xSignBit ^ ySignBit;
  if (xCarryBit | yCarryBit) {
    if (lowBitsSum & 0x40000000) return lowBitsSum ^ 0xc0000000 ^ xSignBit ^ ySignBit;
    return lowBitsSum ^ 0x40000000 ^ xSignBit ^ ySignBit;
  }
  return lowBitsSum ^ xSignBit ^ ySignBit;
}

// F函数
function f(x: number, y: number, z: number) {
  return (x & y) | (~x & z);
}

// G函数
function g(x: number, y: number, z: number) {
  return (x & z) | (y & ~z);
}

// H函数
function h(x: number, y: number, z: number) {
  return x ^ y ^ z;
}

// I函数
function i(x: number, y: number, z: number) {
  return y ^ (x | ~z);
}

// FF轮
function ff(p: Array<number>) {
  const [a, b, c, d, x, s, ac] = p;
  const v = addUnsigned(a, addUnsigned(addUnsigned(f(b, c, d), x), ac));
  return addUnsigned(rotateLeft(v, s), b);
}

// GG轮
function gg(p: Array<number>) {
  const [a, b, c, d, x, s, ac] = p;
  const v = addUnsigned(a, addUnsigned(addUnsigned(g(b, c, d), x), ac));
  return addUnsigned(rotateLeft(v, s), b);
}

// HH轮
function hh(p: Array<number>) {
  const [a, b, c, d, x, s, ac] = p;
  const v = addUnsigned(a, addUnsigned(addUnsigned(h(b, c, d), x), ac));
  return addUnsigned(rotateLeft(v, s), b);
}

// II轮
function ii(p: Array<number>) {
  const [a, b, c, d, x, s, ac] = p;
  const v = addUnsigned(a, addUnsigned(addUnsigned(i(b, c, d), x), ac));
  return addUnsigned(rotateLeft(v, s), b);
}

// MD5主循环
function performMd5Rounds(x: Array<number>, k: number, p: Array<number>) {
  let [a, b, c, d] = p;
  const s = [7, 12, 17, 22, 5, 9, 14, 20, 4, 11, 16, 23, 6, 10, 15, 21];

  a = ff([a, b, c, d, x[k + 0], s[0], 0xd76aa478]);
  d = ff([d, a, b, c, x[k + 1], s[1], 0xe8c7b756]);
  c = ff([c, d, a, b, x[k + 2], s[2], 0x242070db]);
  b = ff([b, c, d, a, x[k + 3], s[3], 0xc1bdceee]);
  a = ff([a, b, c, d, x[k + 4], s[0], 0xf57c0faf]);
  d = ff([d, a, b, c, x[k + 5], s[1], 0x4787c62a]);
  c = ff([c, d, a, b, x[k + 6], s[2], 0xa8304613]);
  b = ff([b, c, d, a, x[k + 7], s[3], 0xfd469501]);
  a = ff([a, b, c, d, x[k + 8], s[0], 0x698098d8]);
  d = ff([d, a, b, c, x[k + 9], s[1], 0x8b44f7af]);
  c = ff([c, d, a, b, x[k + 10], s[2], 0xffff5bb1]);
  b = ff([b, c, d, a, x[k + 11], s[3], 0x895cd7be]);
  a = ff([a, b, c, d, x[k + 12], s[0], 0x6b901122]);
  d = ff([d, a, b, c, x[k + 13], s[1], 0xfd987193]);
  c = ff([c, d, a, b, x[k + 14], s[2], 0xa679438e]);
  b = ff([b, c, d, a, x[k + 15], s[3], 0x49b40821]);

  a = gg([a, b, c, d, x[k + 1], s[4], 0xf61e2562]);
  d = gg([d, a, b, c, x[k + 6], s[5], 0xc040b340]);
  c = gg([c, d, a, b, x[k + 11], s[6], 0x265e5a51]);
  b = gg([b, c, d, a, x[k + 0], s[7], 0xe9b6c7aa]);
  a = gg([a, b, c, d, x[k + 5], s[4], 0xd62f105d]);
  d = gg([d, a, b, c, x[k + 10], s[5], 0x2441453]);
  c = gg([c, d, a, b, x[k + 15], s[6], 0xd8a1e681]);
  b = gg([b, c, d, a, x[k + 4], s[7], 0xe7d3fbc8]);
  a = gg([a, b, c, d, x[k + 9], s[4], 0x21e1cde6]);
  d = gg([d, a, b, c, x[k + 14], s[5], 0xc33707d6]);
  c = gg([c, d, a, b, x[k + 3], s[6], 0xf4d50d87]);
  b = gg([b, c, d, a, x[k + 8], s[7], 0x455a14ed]);
  a = gg([a, b, c, d, x[k + 13], s[4], 0xa9e3e905]);
  d = gg([d, a, b, c, x[k + 2], s[5], 0xfcefa3f8]);
  c = gg([c, d, a, b, x[k + 7], s[6], 0x676f02d9]);
  b = gg([b, c, d, a, x[k + 12], s[7], 0x8d2a4c8a]);

  a = hh([a, b, c, d, x[k + 5], s[8], 0xfffa3942]);
  d = hh([d, a, b, c, x[k + 8], s[9], 0x8771f681]);
  c = hh([c, d, a, b, x[k + 11], s[10], 0x6d9d6122]);
  b = hh([b, c, d, a, x[k + 14], s[11], 0xfde5380c]);
  a = hh([a, b, c, d, x[k + 1], s[8], 0xa4beea44]);
  d = hh([d, a, b, c, x[k + 4], s[9], 0x4bdecfa9]);
  c = hh([c, d, a, b, x[k + 7], s[10], 0xf6bb4b60]);
  b = hh([b, c, d, a, x[k + 10], s[11], 0xbebfbc70]);
  a = hh([a, b, c, d, x[k + 13], s[8], 0x289b7ec6]);
  d = hh([d, a, b, c, x[k + 0], s[9], 0xeaa127fa]);
  c = hh([c, d, a, b, x[k + 3], s[10], 0xd4ef3085]);
  b = hh([b, c, d, a, x[k + 6], s[11], 0x4881d05]);
  a = hh([a, b, c, d, x[k + 9], s[8], 0xd9d4d039]);
  d = hh([d, a, b, c, x[k + 12], s[9], 0xe6db99e5]);
  c = hh([c, d, a, b, x[k + 15], s[10], 0x1fa27cf8]);
  b = hh([b, c, d, a, x[k + 2], s[11], 0xc4ac5665]);

  a = ii([a, b, c, d, x[k + 0], s[12], 0xf4292244]);
  d = ii([d, a, b, c, x[k + 7], s[13], 0x432aff97]);
  c = ii([c, d, a, b, x[k + 14], s[14], 0xab9423a7]);
  b = ii([b, c, d, a, x[k + 5], s[15], 0xfc93a039]);
  a = ii([a, b, c, d, x[k + 12], s[12], 0x655b59c3]);
  d = ii([d, a, b, c, x[k + 3], s[13], 0x8f0ccc92]);
  c = ii([c, d, a, b, x[k + 10], s[14], 0xffeff47d]);
  b = ii([b, c, d, a, x[k + 1], s[15], 0x85845dd1]);
  a = ii([a, b, c, d, x[k + 8], s[12], 0x6fa87e4f]);
  d = ii([d, a, b, c, x[k + 15], s[13], 0xfe2ce6e0]);
  c = ii([c, d, a, b, x[k + 6], s[14], 0xa3014314]);
  b = ii([b, c, d, a, x[k + 13], s[15], 0x4e0811a1]);
  a = ii([a, b, c, d, x[k + 4], s[12], 0xf7537e82]);
  d = ii([d, a, b, c, x[k + 11], s[13], 0xbd3af235]);
  c = ii([c, d, a, b, x[k + 2], s[14], 0x2ad7d2bb]);
  b = ii([b, c, d, a, x[k + 9], s[15], 0xeb86d391]);

  return { a, b, c, d };
}

// 计算MD5
export default (value: string): string => {
  const wordArray = convertToWordArray(utf8Encode(value));

  let hashA = 0x67452301;
  let hashB = 0xefcdab89;
  let hashC = 0x98badcfe;
  let hashD = 0x10325476;

  for (let blockIndex = 0; blockIndex < wordArray.length; blockIndex += 16) {
    const originalA = hashA;
    const originalB = hashB;
    const originalC = hashC;
    const originalD = hashD;

    const roundResult = performMd5Rounds(wordArray, blockIndex, [hashA, hashB, hashC, hashD]);

    hashA = addUnsigned(roundResult.a, originalA);
    hashB = addUnsigned(roundResult.b, originalB);
    hashC = addUnsigned(roundResult.c, originalC);
    hashD = addUnsigned(roundResult.d, originalD);
  }

  const hexA = wordToHex(hashA);
  const hexB = wordToHex(hashB);
  const hexC = wordToHex(hashC);
  const hexD = wordToHex(hashD);

  return `${hexA}${hexB}${hexC}${hexD}`.toLowerCase();
};
